/** iderp con vista admin en Twilio Fast, Unificado, CRM Alumnos y CRM Alumnos Fast */
export const TWILIO_USUARIOS_ADMIN = [
  334, 3015, 1, 568, 32, 718, 1183, 1258, 2155, 2268, 2269, 2342, 954, 2472,
  2556, 2574, 2230, 2767, 2817, 1312, 2910, 2354, 2493, 1794, 1152, 161, 3042,
  2548, // Valeria Monroy Silva — navegar entre vendedoras en Twilio Fast
  3155, // Todas las conversaciones en Twilio Unificado INBI y Twilio Fast, sin reloj checador
]

export function esUsuarioTwilioAdmin (iderp) {
  const id = Number(iderp)
  if (Number.isFinite(id) && TWILIO_USUARIOS_ADMIN.includes(id)) return true
  return TWILIO_USUARIOS_ADMIN.includes(iderp)
}

/**
 * Quién puede reasignar chats en Twilio Fast (icono mdi-account-switch).
 */
export const REASSIGN_TWILIO_FAST = [
  1, 334, 568, 2767, 2548, // 2548 Valeria Monroy Silva
]

export function puedeReasignarTwilioFast (iderp) {
  const id = Number(iderp)
  return Number.isFinite(id) && REASSIGN_TWILIO_FAST.includes(id)
}

/** Menú directo: Twilio Unificado INBI y Twilio Fast (sin abrir el permiso al puesto). */
export const IDERPS_MENU_TWILIO_UNIFICADO_FAST = [3155]

const VISTAS_TWILIO_UNIFICADO_FAST = [
  { title: 'Twilio Unificado INBI', path: 'twilioUnificado' },
  { title: 'Twilio Fast', path: 'TwilioFast' },
]

function menuTienePath (menu, path) {
  if (!Array.isArray(menu)) return false
  for (const top of menu) {
    const cats = top && top.items ? top.items : []
    for (const cat of cats) {
      if (cat && cat.path === path) return true
      const children = cat && cat.items ? cat.items : []
      for (const child of children) {
        if (child && child.path === path) return true
      }
    }
  }
  return false
}

function normTitulo (t) {
  return String(t || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')
}

/**
 * Inyecta Twilio Unificado INBI y Twilio Fast si el iderp está en la lista
 * y el menú del puesto aún no las trae.
 */
export function asegurarMenuTwilioUnificadoFast (menu, iderp) {
  const id = Number(iderp)
  if (!Number.isFinite(id) || !IDERPS_MENU_TWILIO_UNIFICADO_FAST.includes(id)) {
    return Array.isArray(menu) ? menu : []
  }

  const list = Array.isArray(menu) ? menu : []
  const faltantes = VISTAS_TWILIO_UNIFICADO_FAST.filter((v) => !menuTienePath(list, v.path))
  if (!faltantes.length) return list

  const acciones = faltantes.map((v) => ({
    title: v.title,
    path: v.path,
    icon: 'mdi mdi-circle-medium theme--light',
    active: 0,
  }))

  let menuCrm = list.find((m) => {
    const t = normTitulo(m && m.title)
    return t.includes('crm') && t.includes('prospect')
  })
  if (!menuCrm) {
    menuCrm = list.find((m) => normTitulo(m && m.title).includes('prospect'))
  }
  if (!menuCrm) {
    menuCrm = {
      title: 'CRM Prospectos',
      action: 'mdi-account-group',
      active: false,
      items: [],
    }
    list.push(menuCrm)
  }
  if (!Array.isArray(menuCrm.items)) menuCrm.items = []

  let submenuWha = menuCrm.items.find((it) => {
    const t = normTitulo(it && it.title)
    return t.includes('whatsapp') || t === 'whats app'
  })
  if (!submenuWha) {
    submenuWha = {
      title: 'WhatsApp',
      action: 'mdi-whatsapp',
      active: false,
      items: [],
    }
    menuCrm.items.push(submenuWha)
  }
  if (!Array.isArray(submenuWha.items)) submenuWha.items = []
  submenuWha.items.push(...acciones)
  return list
}

/** Recepcionista con todos los planteles INBI/FAST en CRM Alumnos (Naomi 2781). Ticket 80264: se retiró 2797. */
export const CRM_RECEPCION_TODOS_PLANTELES = [2781]

export function esRecepcionTodosPlantelesCrm (iderp) {
  const id = Number(iderp)
  return Number.isFinite(id) && CRM_RECEPCION_TODOS_PLANTELES.includes(id)
}

/** Recepcionista sin esa excepción: solo su plantel, igual que Corte diario. */
export function restringeCrmAlPlantelRecepcion (usuario) {
  if (!usuario || Number(usuario.idpuesto) !== 19) return false
  return !esRecepcionTodosPlantelesCrm(usuario.iderp)
}
